import React, { useState, useEffect, Fragment, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
    Box,
    Card,
    Button,
    makeStyles,
    Container,
    Divider,
    CardContent,
    CardHeader,
    Grid,
    TextField,
    MenuItem,
    InputLabel,
    Checkbox,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    Paper,
    TableBody,
    TablePagination,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { useNavigate } from 'react-router-dom';
import authService from '../../../../utils/permissionAuth';
import tokenService from '../../../../utils/tokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import * as Yup from "yup";
import { LoadingComponent } from 'src/utils/newLoader';
import { Formik } from 'formik';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { useAlert } from "react-alert";
import VisibilityIcon from '@material-ui/icons/Visibility';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import PayslipView from './View';
import CreatePDF from './CreatePDF';
import ReactToPrint from 'react-to-print';
import MultiPagePrintWrapper from './MultiPagePrintWrapper';
const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    },
    colorCancel: {
        color: "white",
        backgroundColor: "red",
    }
}));

const screenCode = 'CREATEPAYSLIPNEW';

export default function Payslip() {
    const componentRef = useRef([]);
    const individualRefs = useRef({});
    const alert = useAlert();
    const navigate = useNavigate();
    const [title, setTitle] = useState("Create Payslip");
    const classes = useStyles();
    const [groups, setGroups] = useState();
    const [factories, setFactories] = useState();
    const [routes, setRoutes] = useState([]);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [emplyeesDetails, setEmplyeesDetails] = useState([]);
    const [templateData, setTemplateData] = useState([]);
    const [selectedEmployees, setSelectedEmployees] = useState([]);
    const [dataLoaded, setDataLoaded] = useState(false);
    const [selectedEmployeesTemplateData, setSelectedEmployeesTemplateData] = useState([]);
    const [page, setPage] = useState(0);
    const [limit, setLimit] = useState(5);
    const [openModal, setOpenModal] = useState(false);
    const [viewData, setViewData] = useState(null);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });
    const [maxAllowedDate, setMaxAllowedDate] = useState(null);
    const [paySlipInput, setPaySlipInput] = useState({
        groupID: 0,
        factoryID: 0,
        routeID: 0,
        empNo: '',
        year: new Date().getUTCFullYear().toString(),
        month: ((new Date().getUTCMonth()) + 1).toString().padStart(2, '0'),
    });
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupName: '0',
        factoryName: '0',
        routeName: '0',
        empNo: '',
        year: '',
        monthName: ''
    });
    const handleLimitChange = (event) => {
        setLimit(event.target.value);
    };
    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    useEffect(() => {
        trackPromise(getGroupsForDropdown(), getPermission());
    }, []);

    useEffect(() => {
        trackPromise(getFactoriesForDropdown());
    }, [paySlipInput.groupID]);
    useEffect(() => {
        trackPromise(getRoutesByFactoryID());
    }, [paySlipInput.factoryID]);

    useEffect(() => {
        const values = templateData
            .filter(data => selectedEmployees.includes(data?.customerAccountID))
            .sort((a, b) => {
                const regA = a.regNo ? a.regNo.toString() : '';
                const regB = b.regNo ? b.regNo.toString() : '';
                return regA.localeCompare(regB, undefined, { numeric: true, sensitivity: 'base' });
            });
        setSelectedEmployeesTemplateData(values);
    }, [selectedEmployees]);

    useEffect(() => {
        if (paySlipInput.factoryID > 0 && paySlipInput.groupID > 0) {
            trackPromise(GetBalancePaymentYearMonthForDropDown());
        }
    }, [paySlipInput.factoryID, paySlipInput.groupID]);
    async function getPermission() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWCREATEPAYSLIPNEW');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined
        });

        setPaySlipInput({
            ...paySlipInput,
            groupID: parseInt(tokenService.getGroupIDFromToken()),
            factoryID: parseInt(tokenService.getFactoryIDFromToken())
        })
    }

    async function getGroupsForDropdown() {
        const groups = await services.getAllGroups();
        setGroups(groups);
    }
    async function getFactoriesForDropdown() {
        const factories = await services.getFactoryByGroupID(paySlipInput.groupID);
        setFactories(factories);
    }
    async function getRoutesByFactoryID() {
        const routeList = await services.getRoutesForDropDown(paySlipInput.factoryID);
        setRoutes(routeList);
    }
    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }

    function handleChange(e) {
        const target = e.target;
        const value = target.value;
        if (target.name === 'groupID') {
            setPaySlipInput({
                ...paySlipInput,
                [e.target.name]: value,
                factoryID: 0,
                routeID: 0
            });
        } else if (target.name === 'factoryID') {
            setPaySlipInput({
                ...paySlipInput,
                [e.target.name]: value,
                routeID: 0
            });
        }
        else {
            setPaySlipInput({
                ...paySlipInput,
                [e.target.name]: value
            });
        }
        setEmplyeesDetails([]);
    }

    function handleDateChange(date) {
        let monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        var month = (date.getMonth() + 1).toString().padStart(2, '0');
        var year = date.getFullYear();
        let monthName = monthNames[month - 1];
        setPaySlipInput({
            ...paySlipInput,
            month: month.toString(),
            year: year.toString()
        });
        setSelectedSearchValues({
            ...selectedSearchValues,
            monthName: monthName,
        });
        if (selectedDate != null) {
            var prevMonth = selectedDate.getMonth() + 1;
            var prevyear = selectedDate.getFullYear();
            if ((prevyear == year && prevMonth != month) || (prevyear != year)) {
                setSelectedDate(date)
            }
        } else {
            setSelectedDate(date)
        }
        setEmplyeesDetails([]);
        setSelectedEmployeesTemplateData([]);
        setDataLoaded(false);
    }

    async function handleSearch() {
        setEmplyeesDetails([]);
        setSelectedEmployeesTemplateData([]);
        setDataLoaded(false);
        setSelectedSearchValues({
            ...selectedSearchValues,
            groupName: groups[paySlipInput.groupID],
            factoryName: factories[paySlipInput.factoryID],
            empNo: paySlipInput.empNo,
            year: paySlipInput.year
        });
        let model = {
            groupID: paySlipInput.groupID,
            factoryID: paySlipInput.factoryID,
            empNo: paySlipInput.empNo,
            applicableMonth: paySlipInput.month,
            applicableYear: paySlipInput.year
        }
        if (paySlipInput.routeID != null && paySlipInput.routeID > 0) {
            model.routeID = paySlipInput.routeID
        }
        trackPromise(GetEmployeesForPaySlip(model));
    }

    async function GetBalancePaymentYearMonthForDropDown() {
        var response = await services.GetBalancePaymentYearMonth(
            paySlipInput.groupID,
            paySlipInput.factoryID
        );

        const applicableYear = parseInt(response.applicableYear);
        const applicableMonth = parseInt(response.applicableMonth);

        const date = new Date(applicableYear, applicableMonth - 1);

        let monthNames = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"];

        setMaxAllowedDate(date);
        setSelectedDate(date);
        setSelectedSearchValues(prev => ({
            ...prev,
            monthName: monthNames[applicableMonth - 1],
            year: applicableYear.toString()
        }));
        setPaySlipInput(prev => ({
            ...prev,
            month: applicableMonth.toString().padStart(2, '0'),
            year: applicableYear.toString()
        }));
    }

    async function GetEmployeesForPaySlip(model) {
        let response = await services.GetEmployeesForPaySlip(model);
        if (response.data.length > 0) {
            setEmplyeesDetails(response.data);
            await GetPaySlipDetails(model);
        } else {
            alert.error("No records found.")
        }
    }

    async function GetPaySlipDetails(model) {
        let response = await services.GetPaySlipDetails(model);
        setTemplateData(response.data)
        setTimeout(setDataLoaded(true), 3000);
    }

    const handleClickView = (data) => {
        setViewData(data);
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
        setViewData(null);
    };

    const handleSelectEmployee = (customerAccountID) => {
        setSelectedEmployees(prev => {
            if (prev.includes(customerAccountID)) {
                return prev.filter(id => id !== customerAccountID);
            } else {
                return [...prev, customerAccountID];
            }
        });
    };
    const handleSelectAll = (event) => {
        if (event.target.checked) {
            const allIds = emplyeesDetails.map(emp => emp.customerAccountID);
            setSelectedEmployees(allIds);
        } else {
            setSelectedEmployees([]);
        }
    };

    const getPageMargins = () => {
        return `@media print {
        @page {
            background-color: white !important;
            size: letter !important;
            margin: 0 !important;
        }
        body {
            background-color: white !important;
        }
    }`;
    };

    return (
        <Fragment>
            <LoadingComponent />
            <Page className={classes.root} title={title}>
                <Container maxWidth={false}>
                    <Formik
                        initialValues={{
                            groupID: paySlipInput.groupID,
                            factoryID: paySlipInput.factoryID,
                            routeID: paySlipInput.routeID,
                            empNo: paySlipInput.empNo
                        }}
                        validationSchema={
                            Yup.object().shape({
                                groupID: Yup.number().required('Group is required').min("1", 'Group is required'),
                                factoryID: Yup.number().required('Factory is required').min("1", 'Factory is required'),
                                empNo: Yup.number().typeError('Employee number must be a valid number').integer('Employee number must be a valid number'),
                                routeID: Yup.number().required('Route is required').min("1", 'Route is required')
                            })
                        }
                        onSubmit={() => trackPromise(handleSearch())}
                        enableReinitialize
                    >
                        {({
                            errors,
                            handleBlur,
                            handleSubmit,
                            touched
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Box mt={0}>
                                    <Card>
                                        <CardHeader title={title} />
                                        <PerfectScrollbar>
                                            <Divider />
                                            <CardContent>
                                                <Grid container spacing={3}>
                                                    <Grid item md={4} xs={12}>
                                                        <InputLabel shrink id="groupID">
                                                            Group  *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.groupID && errors.groupID)}
                                                            helperText={touched.groupID && errors.groupID}
                                                            fullWidth
                                                            name="groupID"
                                                            onChange={(e) => handleChange(e)}
                                                            value={paySlipInput.groupID}
                                                            variant="outlined"
                                                            size="small"
                                                            onBlur={handleBlur}
                                                            InputProps={{
                                                                readOnly: !permissionList.isGroupFilterEnabled,
                                                            }}
                                                        >
                                                            <MenuItem value="0">--Select Group--</MenuItem>
                                                            {generateDropDownMenu(groups)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={4} xs={12}>
                                                        <InputLabel shrink id="factoryID">
                                                            Factory *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.factoryID && errors.factoryID)}
                                                            fullWidth
                                                            helperText={touched.factoryID && errors.factoryID}
                                                            name="factoryID"
                                                            placeholder='--Select Factory--'
                                                            onBlur={handleBlur}
                                                            size='small'
                                                            onChange={(e) => {
                                                                handleChange(e)
                                                            }}
                                                            value={paySlipInput.factoryID}
                                                            variant="outlined"
                                                            id="factoryID"
                                                            InputProps={{
                                                                readOnly: !permissionList.isFactoryFilterEnabled ? true : false
                                                            }}
                                                        >
                                                            <MenuItem value={0}>--Select Factory--</MenuItem>
                                                            {generateDropDownMenu(factories)}
                                                        </TextField>
                                                    </Grid>

                                                    <Grid item md={4} xs={12}>
                                                        <InputLabel shrink id="routeID">
                                                            Route *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.routeID && errors.routeID)}
                                                            helperText={touched.routeID && errors.routeID}
                                                            fullWidth
                                                            name="routeID"
                                                            size='small'
                                                            onBlur={handleBlur}
                                                            onChange={(e) => handleChange(e)}
                                                            value={paySlipInput.routeID}
                                                            variant="outlined"
                                                        >
                                                            <MenuItem value="0">--Select Route--</MenuItem>
                                                            {generateDropDownMenu(routes)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={4} xs={12}>
                                                        <InputLabel shrink id="empNo">
                                                            Registration Number
                                                        </InputLabel>
                                                        <TextField
                                                            error={Boolean(touched.empNo && errors.empNo)}
                                                            fullWidth
                                                            helperText={touched.empNo && errors.empNo}
                                                            name="empNo"
                                                            onBlur={handleBlur}
                                                            size='small'
                                                            onChange={(e) => handleChange(e)}
                                                            value={paySlipInput.empNo}
                                                            variant="outlined"
                                                            id="empNo"
                                                            type="text"
                                                        >
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={3} xs={12}>
                                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                            <DatePicker
                                                                autoOk
                                                                variant="inline"
                                                                openTo="month"
                                                                views={["year", "month"]}
                                                                label="Year and Month *"
                                                                helperText="Select applicable month"
                                                                value={selectedDate}
                                                                maxDate={maxAllowedDate || new Date()}
                                                                onChange={(date) => handleDateChange(date)}
                                                                size='small'
                                                            />
                                                        </MuiPickersUtilsProvider>
                                                    </Grid>
                                                </Grid>
                                                <br />
                                                <Box display="flex" flexDirection="row-reverse" p={2} >
                                                    <Button
                                                        color="primary"
                                                        type="submit"
                                                        variant="contained"
                                                    >
                                                        Search
                                                    </Button>
                                                </Box>
                                            </CardContent>
                                        </PerfectScrollbar>
                                        <PerfectScrollbar>
                                            {emplyeesDetails.length > 0 ?
                                                <div>
                                                    <TableContainer component={Paper} style={{ padding: '8px' }}>
                                                        <Table className={classes.table} aria-label="simple table">
                                                            <TableHead>
                                                                <TableRow style={{ border: "1px solid black" }}>
                                                                    <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid black", width: '8%' }}>
                                                                        <Checkbox
                                                                            checked={selectedEmployees.length === emplyeesDetails.length && emplyeesDetails.length > 0}
                                                                            indeterminate={selectedEmployees.length > 0 && selectedEmployees.length < emplyeesDetails.length}
                                                                            onChange={handleSelectAll}
                                                                        />
                                                                    </TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid black", width: '8%' }}>Registration Number</TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid black", width: '34%' }}>Customer Name</TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid black", width: '20%' }}>Amount</TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid black", width: '10%' }}>Applicable Month</TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid black", width: '10%' }}>Applicable Year</TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid black", width: '10%' }}>View</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {emplyeesDetails.slice(page * limit, page * limit + limit).map((data, index) => (
                                                                    <React.Fragment key={index}>
                                                                        <TableRow>
                                                                            <TableCell align="center" style={{ border: "1px solid black", padding: "4px 8px" }}>
                                                                                <Checkbox
                                                                                    checked={selectedEmployees.includes(data.customerAccountID)}
                                                                                    onChange={() => handleSelectEmployee(data.customerAccountID)}
                                                                                />
                                                                            </TableCell>
                                                                            <TableCell align="center" style={{ border: "1px solid black", padding: "4px 8px" }}>{data.registrationNumber}</TableCell>
                                                                            <TableCell align="left" style={{ border: "1px solid black", padding: "4px 8px" }}>{data.customerName}</TableCell>
                                                                            <TableCell align="right" style={{ border: "1px solid black", padding: "4px 8px" }}>{data.amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                                                            <TableCell align="center" style={{ border: "1px solid black", padding: "4px 8px" }}>{data.applicableMonth}</TableCell>
                                                                            <TableCell align="center" style={{ border: "1px solid black", padding: "4px 8px" }}>{data.applicableYear}</TableCell>
                                                                            <TableCell align="center" style={{ border: "1px solid black", padding: "4px 8px" }}>
                                                                                <IconButton
                                                                                    color="primary"
                                                                                    aria-label="view"
                                                                                    onClick={() => handleClickView(templateData.find(i => i.customerAccountID === data.customerAccountID))}>
                                                                                    <VisibilityIcon />
                                                                                </IconButton>
                                                                                <ReactToPrint
                                                                                    documentTitle={'PaySlip - RegNo - ' + data.regNo + ' - ' + selectedSearchValues.monthName + ', ' + selectedSearchValues.year}
                                                                                    trigger={() => (
                                                                                        <IconButton
                                                                                            style={{ color: '#c81919' }}
                                                                                            aria-label="view"
                                                                                            type='button'>
                                                                                            <PictureAsPdfIcon />
                                                                                        </IconButton>
                                                                                    )}
                                                                                    pageStyle={getPageMargins()}
                                                                                    content={() => individualRefs.current[data.customerAccountID]}
                                                                                />
                                                                                {dataLoaded && (
                                                                                    <div hidden={true}>
                                                                                        <CreatePDF
                                                                                            ref={(r) => (individualRefs.current[data.customerAccountID] = r)}
                                                                                            selectedSearchValues={selectedSearchValues}
                                                                                            paySlipData={templateData.find(i => i.customerAccountID === data.customerAccountID)}
                                                                                            routes={routes}
                                                                                        />
                                                                                    </div>
                                                                                )}
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    </React.Fragment>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                        <TablePagination
                                                            component="div"
                                                            count={emplyeesDetails.length}
                                                            page={page}
                                                            onChangePage={handlePageChange}
                                                            rowsPerPage={limit}
                                                            onChangeRowsPerPage={handleLimitChange}
                                                            rowsPerPageOptions={[5, 10, 25, 50]}
                                                        />
                                                    </TableContainer>
                                                    <Box display="flex" justifyContent="flex-end" p={2}>
                                                        <ReactToPrint
                                                            documentTitle={'PaySlip - ' + selectedSearchValues.monthName + ', ' + selectedSearchValues.year}
                                                            trigger={() => (
                                                                <Button
                                                                    disabled={!(selectedEmployeesTemplateData.length > 0)}
                                                                    className={classes.colorCancel}
                                                                    id="btnRecord"
                                                                    type="button"
                                                                    variant="contained"
                                                                    size="small"
                                                                >
                                                                    PDF
                                                                </Button>
                                                            )}
                                                            pageStyle={getPageMargins()}
                                                            content={() => componentRef.current}
                                                        />
                                                        <div style={{ display: "none" }}>
                                                            <MultiPagePrintWrapper
                                                                ref={componentRef}
                                                                selectedSearchValues={selectedSearchValues}
                                                                selectedEmployeeTemplateData={selectedEmployeesTemplateData}
                                                                routes={routes}
                                                            />
                                                        </div>
                                                    </Box>
                                                </div>
                                                : null}
                                        </PerfectScrollbar>
                                    </Card>
                                </Box>
                            </form>)}
                    </Formik>
                </Container>
                <Dialog
                    open={openModal}
                    onClose={handleCloseModal}
                    maxWidth="lg"
                    fullWidth
                    aria-labelledby="payslip-dialog-title"
                >
                    <DialogTitle id="payslip-dialog-title">Pay Slip Details</DialogTitle>
                    <DialogContent>
                        {viewData && <PayslipView
                            data={viewData}
                            paySlipInput={paySlipInput}
                            routes={routes}
                            searchValues={selectedSearchValues} />}
                    </DialogContent>
                </Dialog>
            </Page>
        </Fragment>
    )
}
